import React from 'react'
import { Link } from 'react-router-dom'

const Empty = props => (
  <div className={`row px-1 justify-content-center py-4 `}>
    <div className='bg-ui-4 radius-circle px-3 py-3'>
      <i className='icon icon_wishlist txt-headline color-brand-1' />
    </div>
    <div className='col-12 clearfix' />
    <div className='col-12 mt-2 mx-2'>
      <h3 className='txt-center txt-body'>
        <strong>Você ainda não favoritou nenhum produto.</strong>
      </h3>
      <p className='txt-center txt-body-sm'>
        Escolha os produtos que você mais gosta e clique no{' '}
        <i className='icon icon_wishlist d-inline-block txt-body' /> que ele
        aparecerá aqui para você.
      </p>
    </div>
    <div className='col-12 clearfix' />
    <div className='col-9 col-md-3 mt-2'>
      <Link to='/'>
        <button className='btn btn-sm btn-featured'>Ver Produtos</button>
      </Link>
    </div>
  </div>
)

export default Empty



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistPage/Empty.js